export default {"src":"/_next/static/media/Group.fdf48ac2.svg","height":160,"width":161};